module.exports = {
  init: function () {
    const $body = $('body');
    const $themeToggle = $('#theme-toggle');

    /// Event handler for changing the theme
    $themeToggle.on('change', function () {
      if ($(this).is(':checked')) {
        $body.addClass('dark');
        document.cookie = "theme=dark;path=/";
      } else {
        $body.removeClass('dark');
        document.cookie = "theme=light;path=/";
      }
    });

    // Initially set the theme from the cookie
    const theme = document.cookie.replace(/(?:(?:^|.*;\s*)theme\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (theme === 'dark') {
      $body.addClass('dark');
      $themeToggle.prop('checked', true);
    }
  }
}
